import {modalIdKey} from './constants';
import {createLocation} from 'history';

export const addOrRemoveModalId = (location, modalId, open) => {
    const params = new URLSearchParams(location.search);
    let modalIds = params.getAll(modalIdKey);
    if (open) {
        modalIds = Array.from(new Set([...modalIds, modalId]));
    } else {
        modalIds = modalIds.filter((id) => id !== modalId);
    }
    params.delete(modalIdKey);
    modalIds.forEach((id) => {
        params.append(modalIdKey, id);
    });

    const newLocation = createLocation(location);
    newLocation.search = params.toString();
    return newLocation;
};
